import Loadable from 'react-loadable';

export const LoadableLoveSurvey = Loadable({
  loader: () => import('./LoveSurvey'),
  loading: () => null
});
